module.exports = __webpack_public_path__ + "static/media/skintype_full.8aa8754e.svg";